import {
  CampaignLinkedCategories,
  UserCompany,
  AssetObject,
  SiteCredentials,
  VisualProductDataCampaignColorParameters,
  TextSearchCampaignPropertiesProductWeights,
  TextSearchCampaignPropertiesImageWeights,
  FilterColumnItem,
} from "@vviinn/user-managment-client-ts";

type ComparableAsString =
  | string
  | number
  | boolean
  | string[]
  | FilterColumnItem[]
  | CampaignLinkedCategories
  | VisualProductDataCampaignColorParameters
  | TextSearchCampaignPropertiesProductWeights
  | TextSearchCampaignPropertiesImageWeights
  | UserCompany[]
  | SiteCredentials
  | AssetObject[]
  | undefined;

export const compareAsStrings = (
  item1: ComparableAsString,
  item2: ComparableAsString,
) => {
  return (item1 || "").toString().localeCompare((item2 || "").toString());
};
